/**
 * Typed API client for the Company Feed (livefeed) module — Epic 219.
 *
 * A tenant-wide corporate news feed: posts with an audience scope, threaded
 * comments, and emoji reactions. Mirrors internal/livefeed on the Go backend.
 */

import { apiClient } from '@/lib/apiClient';

export type FeedAudience = 'global' | 'workgroup' | 'department';

export interface FeedPost {
  id: string;
  authorUserId: string;
  body: string;
  audience: FeedAudience;
  workgroupId: string | null;
  attachments: unknown;
  postedAt: string;
}

export interface FeedComment {
  id: string;
  authorUserId: string;
  body: string;
  commentedAt: string;
}

export async function listFeed(): Promise<FeedPost[]> {
  const { data } = await apiClient.get<FeedPost[]>('/livefeed');
  return data;
}

export interface CreatePostRequest {
  body: string;
  audience?: FeedAudience;
  workgroupId?: string;
}

export async function createPost(req: CreatePostRequest): Promise<{ id: string }> {
  const { data } = await apiClient.post<{ id: string }>('/livefeed', req);
  return data;
}

export async function listComments(postId: string): Promise<FeedComment[]> {
  const { data } = await apiClient.get<FeedComment[]>(`/livefeed/${postId}/comments`);
  return data;
}

export async function addComment(postId: string, body: string): Promise<{ id: string }> {
  const { data } = await apiClient.post<{ id: string }>(`/livefeed/${postId}/comments`, { body });
  return data;
}

export async function reactToPost(postId: string, emoji?: string): Promise<{ id: string }> {
  const { data } = await apiClient.post<{ id: string }>(`/livefeed/${postId}/react`, { emoji });
  return data;
}
